// src/pages/PaymentSuccessPage.js

import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useAuth } from '../context/AuthContext'; // AuthContext'i import ediyoruz

const PaymentSuccessPage = () => {
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const { currentUser } = useAuth();

    useEffect(() => {
        // Stripe'tan gelen session_id'yi URL'den alıyoruz.
        const queryParams = new URLSearchParams(location.search);
        const sessionId = queryParams.get('session_id');

        // Burada normalde session_id'yi backend'e gönderip ödemenin
        // gerçekten başarılı olduğunu teyit etmek en doğrusudur.
        // Şimdilik, kullanıcının rolünün güncellenmesi için kısa bir bekleme süresi simüle ediyoruz.
        console.log("Stripe Session ID:", sessionId);

        const timer = setTimeout(() => {
            setLoading(false);
        }, 1500); // 1.5 saniye sonra yükleme durumunu kapat

        return () => clearTimeout(timer); // Component'ten çıkılırsa timer'ı temizle
    }, [location]);

    return (
        <>
            <Helmet>
                <title>Payment Successful - Welcome!</title>
                <meta name="robots" content="noindex" /> {/* Bu sayfanın arama motorları tarafından indekslenmesini engeller */}
            </Helmet>
            
            <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
                <div className="col-md-6 col-lg-5" style={{ maxWidth: '500px' }}>
                    <div className="card shadow-sm border-0 text-center p-4">
                        {loading ? (
                            <>
                                <h2 className="mb-3">Verifying Payment...</h2>
                                <p className="text-muted">Please wait while we confirm your subscription.</p>
                                <div className="spinner-border text-primary mt-3" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </>
                        ) : (
                            <>
                                <i className="bi bi-check-circle-fill text-success mb-3" style={{ fontSize: '4rem' }}></i>
                                <h1 className="fw-bold">Welcome Aboard!</h1>
                                <p className="lead text-muted mb-4">
                                    Your subscription is now active. You have full access to our exclusive content and community features.
                                </p>
                                <div className="d-grid gap-2">
                                    {currentUser ? (
                                        <Link to="/profile" className="btn btn-primary">
                                            Go to My Profile
                                        </Link>
                                    ) : (
                                        <Link to="/login" className="btn btn-primary">
                                            Login to Your Account
                                        </Link>
                                    )}
                                    <Link to="/directory" className="btn btn-outline-secondary">
                                        Explore the Directory
                                    </Link>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default PaymentSuccessPage;